export function showTeamMembers() {

    const buttons      = document.querySelectorAll(".filter-btn");
    const itemsWrapper = document.querySelector("#team-items");
    const pagination   = document.querySelector(".team-pagination");

    if (!itemsWrapper || !buttons.length) return;

    let allTeamData = [];
    let currentPage = 1;
    let totalPages  = 1;
    const VISIBLE_PAGES = 4;

 
    function getItemsPerPage() {
        if (window.innerWidth <= 600) return 4;  
        if (window.innerWidth <= 768) return 8;   
        return Infinity;                           
    }


    const dropdownToggle = document.querySelector(".dropdown-toggle");
    const dropdownMenu   = document.querySelector(".dropdown-menu");

    if (dropdownToggle && dropdownMenu) {

     
        const toggleText = dropdownToggle.querySelector(".toggle-text");
        if (toggleText) toggleText.textContent = "All";

        buttons.forEach((btn) => {
            const item = document.createElement("button");
            item.className      = "filter-btn";
            item.dataset.filter = btn.dataset.filter;
            item.textContent    = btn.textContent;

         
            if (btn.dataset.filter === "all") {
                item.classList.add("active");
            }

            item.addEventListener("click", () => {
                const filter = item.dataset.filter;

               
                document.querySelectorAll(".dropdown-menu .filter-btn").forEach(b => b.classList.remove("active"));
                item.classList.add("active");

             
                buttons.forEach(b => {
                    if (b.dataset.filter === filter) b.classList.add("active");
                    else b.classList.remove("active");
                });

               
                if (toggleText) toggleText.textContent = item.textContent;

                dropdownMenu.classList.remove("show");
                dropdownToggle.classList.remove("active", "show");

                currentPage = 1;
                loadTeam(filter);
            });

            dropdownMenu.appendChild(item);
        });

        dropdownToggle.addEventListener("click", (e) => {
            e.stopPropagation();
            const isOpen = dropdownMenu.classList.toggle("show");
            dropdownToggle.classList.toggle("show", isOpen);
            dropdownToggle.classList.toggle("active", isOpen);
        });

        document.addEventListener("click", () => {
            dropdownMenu.classList.remove("show");
            dropdownToggle.classList.remove("show", "active");
        });

        dropdownMenu.addEventListener("click", (e) => e.stopPropagation());
    }

    // Sets --team-items-max-height to the actual bottom of the 2nd row of .team-item's,
    // so items beyond row 2 scroll instead of stretching the block. Only applies on the
    // desktop grid (the <=768px breakpoints already force max-height: none in CSS).
    function updateTeamItemsMaxHeight() {
        if (window.innerWidth <= 768) {
            itemsWrapper.style.removeProperty("--team-items-max-height");
            return;
        }

        const items = Array.from(itemsWrapper.children).filter(
            (el) => el.classList && el.classList.contains("team-item")
        );

        if (!items.length) {
            itemsWrapper.style.removeProperty("--team-items-max-height");
            return;
        }

        const wrapperTop = itemsWrapper.getBoundingClientRect().top;
        const itemTops = items.map((item) => Math.round(item.getBoundingClientRect().top - wrapperTop));
        const rowTops = [...new Set(itemTops)].sort((a, b) => a - b);

        const targetRowTop = rowTops[Math.min(1, rowTops.length - 1)];
        const rowBottoms = items
            .filter((_item, i) => itemTops[i] === targetRowTop)
            .map((item) => item.getBoundingClientRect().bottom - wrapperTop);

        itemsWrapper.style.setProperty("--team-items-max-height", `${Math.ceil(Math.max(...rowBottoms))}px`);
    }

    function renderPage() {
        itemsWrapper.innerHTML = "";

        if (!allTeamData.length) {
            itemsWrapper.innerHTML = "<p>No results found.</p>";
            renderPagination();
            itemsWrapper.style.removeProperty("--team-items-max-height");
            return;
        }

        const itemsPerPage = getItemsPerPage();
        const isDesktop    = itemsPerPage === Infinity;


        const pageData = isDesktop
            ? allTeamData
            : allTeamData.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

        pageData.forEach((item) => {
            const div = document.createElement("div");
            div.className = "team-item";

            div.dataset.category = Array.isArray(item.category)
                ? item.category.join(",")
                : (item.category || "");

            if (item.department_head === true) {
                div.setAttribute("department-head", "yes");
            }

            div.innerHTML = `
                <div class="team-item__img-wrap">
                    <img
                        src="${item.image
                            ? item.image
                            : '/wp-content/themes/Wellevate_WP_Theme/assets/img/placeholder-person.webp'}"
                        alt="${item.title || ''}"
                    />
                </div>
                ${item.title    ? `<h3>${item.title}</h3>`  : ""}
                ${item.position ? `<p>${item.position}</p>` : ""}
            `;

            itemsWrapper.appendChild(div);
        });

        renderPagination();
        updateTeamItemsMaxHeight();
    }

    
    function renderPagination() {
        if (!pagination) return;

 
        if (window.innerWidth > 768) {
            pagination.style.display = "none";
            return;
        }

        const itemsPerPage = getItemsPerPage();
        totalPages = Math.ceil(allTeamData.length / itemsPerPage);

        if (totalPages <= 1) {
            pagination.style.display = "none";
            return;
        }

        pagination.style.display = "flex";
        pagination.innerHTML = "";


        const prevBtn = document.createElement("button");
        prevBtn.className = "pagination-btn";
        prevBtn.innerHTML = `
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <polyline points="15 18 9 12 15 6"></polyline>
            </svg>
            Prev
        `;
        prevBtn.disabled = currentPage === 1;
        prevBtn.addEventListener("click", () => {
            if (currentPage > 1) { currentPage--; renderPage(); }
        });
        pagination.appendChild(prevBtn);

       
        let windowStart = Math.max(1, currentPage - Math.floor(VISIBLE_PAGES / 2));
        let windowEnd   = windowStart + VISIBLE_PAGES - 1;

        if (windowEnd > totalPages) {
            windowEnd   = totalPages;
            windowStart = Math.max(1, windowEnd - VISIBLE_PAGES + 1);
        }

        const numbersWrapper = document.createElement("div");
        numbersWrapper.className = "pagination-numbers";

        for (let i = windowStart; i <= windowEnd; i++) {
            const pageBtn = document.createElement("button");
            pageBtn.className   = "page-number" + (i === currentPage ? " active" : "");
            pageBtn.textContent = i;
            pageBtn.addEventListener("click", () => {
                currentPage = i;
                renderPage();
            });
            numbersWrapper.appendChild(pageBtn);
        }

        pagination.appendChild(numbersWrapper);

     
        const nextBtn = document.createElement("button");
        nextBtn.className = "pagination-btn";
        nextBtn.innerHTML = `
            Next
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <polyline points="9 18 15 12 9 6"></polyline>
            </svg>
        `;
        nextBtn.disabled = currentPage === totalPages;
        nextBtn.addEventListener("click", () => {
            if (currentPage < totalPages) { currentPage++; renderPage(); }
        });
        pagination.appendChild(nextBtn);
    }

   
    function loadTeam(filter = "all") {
        fetch(`/wp-json/wellevate/v1/team?filter=${filter}`)
            .then(res => res.json())
            .then(data => {
                allTeamData = data.sort((a, b) => {
                    const orderA = a.sort_order ?? 999;
                    const orderB = b.sort_order ?? 999;
                    if (orderA !== orderB) return orderA - orderB;
                    return (b.department_head ? 1 : 0) - (a.department_head ? 1 : 0);
                });
                currentPage = 1;
                renderPage();
            })
            .catch(err => {
                console.error("Error loading team:", err);
            });
    }


    buttons.forEach((btn) => {
        btn.addEventListener("click", () => {
            const filter = btn.dataset.filter;
            buttons.forEach(b => b.classList.remove("active"));
            btn.classList.add("active");
            currentPage = 1;
            loadTeam(filter);
        });
    });

   
    let resizeTimer;
    window.addEventListener("resize", () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
            currentPage = 1;
            renderPage();
        }, 200);
    });

    // Recalculate once webfonts finish loading, since row height depends on rendered text.
    if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(() => updateTeamItemsMaxHeight());
    }

    // Initial load
    loadTeam("all");
}